import { Component } from '@angular/core';
import { MatDialogContent } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'ed-ingesting',
  imports: [MatDialogContent, MatProgressSpinnerModule],
  templateUrl: './ingesting.component.html',
  styleUrl: './ingesting.component.scss',
})
export class IngestingComponent {}
